import { memo, useState, useCallback } from 'react';

import * as HeaderStore from '@Stores/Header';
import LayoutMain from '@Layouts/LayoutMain';
import PageTopBar from '@Components/PageTopBar';
import { useScrollToView } from '@Hooks/useScrollToView';
import MainBanner from './elements/MainBanner';
import UsefullBlock from './elements/UsefullBlock';
import Tariffs from './elements/Tariffs';
import Advantages from './elements/Advantages';
import Application from './elements/Application';
import OurTeam from './elements/OurTeam';
import OurWork from './elements/OurWork';
import Stripe from './elements/Stripe';
import Proccess from './elements/Proccess';
import styles from './PageExpressDesign.module.css';

import type { FC } from 'react';
import type { ExpressDesignData, PageExpressDesignData } from './type';

interface PageExpressDesignProps {
  data: PageExpressDesignData;
  expressDesignData: ExpressDesignData;
}

const PageExpressDesign: FC<PageExpressDesignProps> = (props) => {
  const { data, expressDesignData, ...restProps } = props;

  const { breadcrumbs, ofertaLink } = data;
  const { usefullBlock, tariffs = [], advantages, team, process, ourWorks } = expressDesignData;
  const [firstTariff] = tariffs;
  const [selectedTariff, setSelectedTariff] = useState(firstTariff);
  const [selectedType, setSelectedType] = useState<string>('');
  const { handleScrollTo } = useScrollToView();
  const { contentHeight } = HeaderStore.useSizes();

  const handleSelectTariff = useCallback(
    (tariffId: string) => {
      const currentTariff = tariffs.filter((tariff) => tariff.id.toString() === tariffId)[0];

      if (currentTariff) {
        setSelectedTariff(currentTariff);
      }
    },
    [tariffs, setSelectedTariff],
  );

  const handleChangeType = (type: string) => {
    setSelectedType(type);
  };

  const handleScrollToBlock = useCallback(
    (e: React.MouseEvent<HTMLDivElement, MouseEvent>, anchorName: string, tariffId: string) => {
      handleSelectTariff(tariffId);

      const element = document.getElementById(anchorName);
      handleScrollTo(element, contentHeight);
    },
    [contentHeight, handleSelectTariff, handleScrollTo],
  );

  return (
    <LayoutMain>
      <div className={styles.wrapper} {...restProps}>
        <PageTopBar breadcrumbs={breadcrumbs} />
        <MainBanner className={styles.mainBanner} onScrollToBlock={handleScrollToBlock} />
        <UsefullBlock className={styles.usefullBlock} items={usefullBlock} />
        <div className={styles.backgroundWrapper}>
          <Tariffs
            className={styles.tariffs}
            tariffs={tariffs}
            onScrollToBlock={handleScrollToBlock}
          />
        </div>
        <Advantages
          className={styles.advantages}
          advantages={advantages}
          onScrollToBlock={handleScrollToBlock}
        />
        <div className={styles.backgroundWrapper}>
          <div className={styles.applicationWrapper} id='express-design-first-application'>
            <Application
              tariffs={tariffs}
              selectedTariff={selectedTariff}
              onSelectTariff={handleSelectTariff}
              onChangeType={handleChangeType}
              selectedType={selectedType}
              ofertaLink={ofertaLink}
            />
          </div>
        </div>
        <div className={styles.process}>
          <Proccess process={process} onScrollToBlock={handleScrollToBlock} />
        </div>
        <Stripe />
        <OurWork className={styles.ideas} ourWorks={ourWorks} />
        <Stripe />
        <OurTeam className={styles.ourTeam} team={team} />
        <div className={styles.backgroundWrapper}>
          <div className={styles.applicationWrapper} id='express-design-second-application'>
            <Application
              tariffs={tariffs}
              selectedTariff={selectedTariff}
              onSelectTariff={handleSelectTariff}
              onChangeType={handleChangeType}
              selectedType={selectedType}
              ofertaLink={ofertaLink}
            />
          </div>
        </div>
      </div>
    </LayoutMain>
  );
};

export default memo(PageExpressDesign);
